/**
 * Part 24d, principle 2: a staged import's record as the book it is handed to holds it (`adopt-import`, in both adapters).
 * Pure.
 */

/**
 * S′5, N1: `raw` (a record of a staging book) as book `to` holds it: its `bookId` is `to`, and its `chapterId`, when
 * `chapters` maps it (a staging ID of a chapter the book has), the chapter it maps to.
 */
export function adopted(raw: unknown, to: string, chapters: ReadonlyMap<string, string>): unknown {
  const chapterId: unknown = Reflect.get(Object(raw), 'chapterId');
  const mapped = typeof chapterId === 'string' ? chapters.get(chapterId) : undefined;
  return Object.assign({}, raw, { bookId: to }, mapped === undefined ? {} : { chapterId: mapped });
}
